export enum IncidentDetailsFillState {
  NotFilled = 'not-filled',
  HalfFilled = 'half-filled',
  Filled = 'filled',
}
